var React = require('react');

function Location (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"location-path","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("path",{"d":"M2.39955149,6.72467972 L13.0641816,2.05801306 C13.6199015,1.81483913 14.1851255,2.38017104 13.941998,2.93599717 L9.27622237,13.6026638 C9.01540914,14.1989222 8.1425076,14.1063741 8.01247284,13.4686766 L7.08373481,8.91409528 L2.53449201,7.9888695 C1.89622073,7.85966418 1.80293828,6.98574785 2.39955149,6.72467972 Z","fill":"#3A66E5"})));
}

Location.displayName = "Location";

Location.defaultProps = {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1"};

module.exports = Location;

Location.default = Location;
